import React from "react";

import Span from "@atoms/Span";

import useTranslation from "@languages/useTranslation";

import { Close } from "@libraries/mui/icons";
import { TabProps as TabPropsMUI } from "@libraries/mui/components";

import * as Styled from "./styles";

export interface TabProps extends TabPropsMUI {
  title: string;
  titleParam?: string;
  caption: string;
  fixed?: boolean;
}

export interface TabComponentProps extends TabPropsMUI {
  tab: TabProps;
  onClose: () => void;
}

const Tab: React.FC<TabComponentProps> = ({ tab, onClose, ...rest }) => {

  const { t } = useTranslation();
  const { title, caption, fixed = false, titleParam } = tab;

  const onCloseTab = (event: React.MouseEvent<SVGSVGElement>) => {
    event.stopPropagation();
    onClose();
  };

  const IconTab = !fixed ? <Close onClick={(evt) => onCloseTab(evt)} /> : <div />;

  return (
    <Styled.Container
      label={(
        <Styled.Name>
          <Span>{t(title, { titleParam })}</Span>
          <Span>{t(caption)}</Span>
        </Styled.Name>
    )}
      icon={IconTab}
      iconPosition="end"
      {...rest}
    />
  );
};

export default Tab;
